import { useNavigate } from "react-router";
import { fetchToken } from "./Auth";
import { useEffect, useState } from "react";
import axios from "axios";
import zxcvbn from "zxcvbn";
import { TitleImage, InputTextField} from "./BaseComponents";

export default function Signup() {
  const navigate = useNavigate();
  const [Userparams, setUserparams] = useState({});
  const handleFormChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setUserparams(values => ({...values, [name]: value}))
  }

  //check to see if the fields are not empty
  const signup = () => {
    if ((Userparams.username === "") || (Userparams.password === "")) {
      return;
    } else {
      // determine password strength
      const pwd_strength = zxcvbn(Userparams.password);

      // check if user exists
      let user_exists;
      axios.post("/api/user_exists", {
          username: Userparams.username,
          password: Userparams.password,
        })
        .then(function (response) {
          if (String(response.data) === "True"){
            user_exists = true;
          } else {
            user_exists = false;
          }
        })
        .then( function () {
          if ((pwd_strength.score >= 3) && (user_exists === false)) {
            // make api call to our backend. we'll leave thisfor later
            axios.post("/api/signup", {
                username: Userparams.username,
                password: Userparams.password,
                full_name: Userparams.fullname,
                email: Userparams.email,
              })
              .then(function (response) {
                navigate("/");
              })
              .catch(function (error) {
                console.log(error, "error");
              });
            } else if (user_exists === true){
              alert("user already exists, try another username.")
            } else if (pwd_strength.score < 3){
              alert("password is too weak, randomize and try again.")
            };
        });
    };
  };

  // Avoid going to the login page if you are already logged in
  useEffect((navigate) => {
  if (fetchToken()) {
    navigate("/profile");
  };
  }, []);

  return (
    <div className="App-body">
      {TitleImage()}
      <div className="ContentBorder">
        <form className="Form">
          <div className="Form-fields">
            {InputTextField("username","username",Userparams.username,handleFormChange)}
            {InputTextField("password","password",Userparams.password,handleFormChange)}
            {InputTextField("fullname","fullname",Userparams.fullname,handleFormChange)}
            {InputTextField("email","email",Userparams.email,handleFormChange)}
            <button type="button" onClick={signup}>
              signup
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
